<template>
	<div>
		<ul class="list-unstyled">
			<li v-for="request in requests" :key="request.key">
				<p><a :href="request.url">{{ request.url }}</a></p>
				<pre style="max-height: 200px;">
					{{ request.options }}
				</pre>
				<button class="btn btn-primary" @click="retryRequest(request)">Retry</button> <button class="btn btn-danger" @click="deleteRequest(request)">{{ $t('delete') }}</button>
			</li>
		</ul>
		<template v-if="!requests.length">
			{{ $t('no-requests-to-retry') }}
		</template>
	</div>
</template>

<script>
import retryrequests from "../../include/indexeddb/stores/retryrequests";
export default {
	components: {
	},
	data: function() {
		return {
			requests: []
		};
	},
	mounted() {
		this.getRequests();
	},
	methods: {
		async getRequests() {
			this.requests = await retryrequests.getRequests();
		},
		retryRequest(request) {
			this.$store.commit("showBlockingSpinner");
			this.$cfetch(request.url, request.options, request.key)
			/* eslint-disable no-unused-vars */
			.then(json => {
				this.getRequests();
				this.$store.commit("hideBlockingSpinner");
			})
			.catch(error => {
				this.getRequests();
				this.$store.commit("hideBlockingSpinner");
			});	
			/* eslint-enable no-unused-vars */
		},
		deleteRequest(request) {
			retryrequests.deleteRequestByKey(request.key);
			this.getRequests();
		}
	}
};
</script>
